var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5L12 10.5M12 10.5L7.99996 14.5M12 10.5V19.5M20.39 16.89C21.3653 16.3583 22.1358 15.5169 22.5798 14.4986C23.0239 13.4804 23.1162 12.3432 22.8422 11.2667C22.5682 10.1901 21.9434 9.2355 21.0666 8.55343C20.1898 7.87137 19.1108 7.50072 18 7.49998H16.74C16.4373 6.32923 15.8731 5.24232 15.0899 4.32098C14.3067 3.39964 13.3248 2.66783 12.2181 2.18059C11.1113 1.69335 9.90851 1.46334 8.70008 1.50787C7.49164 1.55239 6.30903 1.87028 5.24114 2.43765C4.17325 3.00501 3.24787 3.80709 2.53458 4.78357C1.82129 5.76004 1.33865 6.88552 1.12294 8.07538C0.90723 9.26524 0.964065 10.4885 1.28917 11.6532C1.61428 12.818 2.1992 13.8938 2.99996 14.8",
    stroke: "inherit",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.2fcff225.svg";
export { ForwardRef as ReactComponent };